import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/entities/core/market/components/MarketList.jsx");
